// removed by extract-text-webpack-plugin
module.exports = {"gray500":"#adb5bd","progress":"ProgressBar__progress--2IVUZ","progressBar":"ProgressBar__progressBar--2P5jN","progressText":"ProgressBar__progressText--SR2b_","badge":"ProgressBar__badge--3km-h","Pointer":"ProgressBar__Pointer--HOBki","progressLabels":"ProgressBar__progressLabels--upqpJ","thresholdLabel":"ProgressBar__thresholdLabel--dkFUZ","threshold1Label":"ProgressBar__threshold1Label--wRWEl","threshold2Label":"ProgressBar__threshold2Label--Qonsf","thresholdLine":"ProgressBar__thresholdLine--vkSwZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ProgressBar/ProgressBar.scss
// module id = 429
// module chunks = 0